export default __webpack_public_path__ + "img/feaf4a1e83ea082e80011396b452e1d7.svg";